import * as yup from 'yup';

export const schema = yup.object({
  checkIn: yup.date().label('Check-in').required(),
  checkOut: yup.date().label('Check-out').required(),
});
